

import Component from 'generic.basecomponent';
import app from 'app-instance';
import helpers from 'helpers';
import CustomDonateForm from './custom-donate-form';
import Tabs from '../../tabs/js/generic.tabs';

export default class CustomDonate extends Component {
    constructor(el) {
        super(el);
        this.input = this.container.querySelector('.js-custom-donate-input');
        this.formNode = this.container.querySelector('.js-custom-donate-form');
        this.tabsContainer = this.container.querySelector('.js-custom-donate-tabs');
        this.currencyContainer = this.container.querySelector('.js-custom-donate-currency');
        this.loginContainer = this.container.querySelector('.js-custom-donate-login-container');

        if (this.formNode) {
            this.isLoggedIn = (this.formNode.getAttribute('data-is-logged-in') === 'true');
        }


        this.init();
    }

    init() {
        if (!this.formInstance && this.formNode !== null) {
            this.formInstance = new CustomDonateForm(this.formNode, this.showLoginForm.bind(this), this.isLoggedIn);
        }

        if (this.tabsContainer) {
            const tabsCallbacks = {
                'monthly-donation': this.onMonthlyTabActivate.bind(this),
                'single-donation': this.onSingleTabActivate.bind(this),
            };
            this.tabsInstance = new Tabs(this.tabsContainer, tabsCallbacks);
        }

        app.addListener('donateAmount:change', this.amountChange.bind(this));
        this.input.addEventListener('input', helpers.throttle(this, this.handleInput, 300));

        setTimeout(() => {
            app.emitEvent('donateAmount:input', [this.input.value]);
        }, 0);

        if (this.loginContainer && this.loginContainer.querySelector('.js-login-block[data-has-error]')) {
            this.showLoginForm();
        }
    }

    amountChange(value) {
        this.input.value = value;
    }

    handleInput() {
        app.emitEvent('donateAmount:input', [this.input.value]);
    }

    showLoginForm() {
        this.loginContainer.removeAttribute('hidden');
    }

    onMonthlyTabActivate() {
        this.hideCurrency();
    }

    onSingleTabActivate() {
        this.showCurrency();
    }

    hideCurrency() {
        if (this.currencyContainer) {
            this.currencyContainer.style.visibility = 'hidden';
        }
    }

    showCurrency() {
        if (this.currencyContainer) {
            this.currencyContainer.style.visibility = 'visible';
        }
    }
}

CustomDonate.id = 0;



// WEBPACK FOOTER //
// ./app/components/custom-donate/js/generic.custom-donate.js